import { ImGapPlan } from '../../../../ng2/shared/services/im-models/im-gap-plan';

angular.module('nv.shared.modals').factory('CreditGapModal', CreditGapModal);

function CreditGapModal($mdDialog, School, Student, GapPlan, ImGapPlan: ImGapPlan) {
  return {
    show(schoolId, studentId, gapPlanId, creditReq, courseCode) {
      const Modes = {
        EDIT_GAP_PLAN: {
          MODE: 'EDIT_GAP_PLAN',
          template: require('./credit-gap-plan-edit-mode.html'),
        },
        ASSIGN_GAP_PLAN: {
          UI: 'ASSIGN_GAP_PLAN',
          template: require('./credit-gap-plan-assign-mode.html'),
        },
      };

      const activeMode = gapPlanId ? Modes.EDIT_GAP_PLAN : Modes.ASSIGN_GAP_PLAN;

      return $mdDialog.show({
        resolve: {
          school() {
            return School.get({ id: schoolId }).$promise;
          },
          student() {
            return Student.get({ id: studentId }).$promise;
          },
          gapPlan() {
            if (gapPlanId) {
              return GapPlan.get({ id: gapPlanId }).$promise;
            } else {
              return ImGapPlan.createNew(studentId, schoolId, Student.get({ id: studentId }).$promise);
            }
          },
        },
        locals: {
          activeMode,
          // empty string to prevent injection error in ctrl
          creditReq: creditReq || '',
          courseCode: courseCode || '',
        },
        disableParentScroll: true,
        templateUrl: activeMode.templateUrl,
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        controller: 'CreditGapModalCtrl',
        controllerAs: 'ctrl',
      });
    },
  };
}
